module.exports = __webpack_public_path__ + "img/section_2.76f3c23c.png";